import { isNotDefined, noop } from '@sgme/fp';
import type { ReactElement } from 'react';

import { useFlexiForwardSelector } from '@/App/tiles/FlexiForward/FlexiForwardContext.ts';
import { getRfsMarginData } from '@/App/tiles/FlexiForward/utils';
import { SgNumberInput } from '@/components/sg-design-system/components/input/SgNumberInput';

export function CommercialMarginRateInput(): ReactElement {
  const marginInBp = useFlexiForwardSelector((flexiForward) => {
    const marginData = getRfsMarginData(flexiForward.properties.rfs);

    return marginData?.askMarkupInBp;
  });

  const rate = isNotDefined(marginInBp) ? undefined : Number.parseFloat(marginInBp);

  // TODO ABO, get is expired
  return <SgNumberInput value={rate} onChange={noop} size="sm" disabled />;
}
